import { object, string } from 'yup'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { brandKitId } from 'components/Wizards/schemas/shared/brandKitId'
import { safify } from 'components/Wizards/schemas/utils/safify'
import { language } from 'components/Wizards/schemas/shared/language'
import { includeEmojis } from 'components/Wizards/schemas/shared/includeEmojis'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { meta } from '../schemaCommon'
import { filename } from 'components/Wizards/schemas/shared/filename'
import { project } from 'components/Wizards/schemas/shared/project'
import { tone } from 'components/Wizards/schemas/shared/voiceTones'

export const FlowLSchema = ({ generationType }: { generationType: string }) => {
  const BasicsSchema = object({
    case_study_customer_name: string()
      .default('')
      .meta({
        label: 'Customer featured in the case study',
        placeholder: 'What is the name of the customer to be highlighted?',
        type: 'text',
      })
      .transform(safify),
    company_basics: string()
      .default('')
      .meta({
        label: 'Tell us about the customer',
        placeholder: 'Brief company description, industry, location, size...',
        type: 'textarea',
        rows: 4,
      })
      .transform(safify),
    brand_kit_id: brandKitId
      .meta({
        label: 'Pick a Brand Kit',
      })
      .optional(),
  }).meta({
    title: 'Share some basics',
    submitLabel: 'Continue',
  }) as StepSchema

  const ChallengeSchema = object({
    case_study_challenges: string()
      .default('')
      .meta({
        label: 'Summarize their experience',
        placeholder: 'Describe the problem your customers were facing...',
        type: 'textarea',
        rows: 4,
      })
      .transform(safify),
  }).meta({
    title: 'What challenge did your customers face?',
    submitLabel: 'Continue',
  }) as StepSchema

  const BusinessHelpSchema = object({
    case_study_solutions: string()
      .default('')
      .meta({
        label: 'Summarize your solution',
        placeholder: 'Describe the solution you provided and how it addressed the challenge...',
        type: 'textarea',
        rows: 4,
      })
      .transform(safify),
  }).meta({
    title: 'How did your business solve it?',
    submitLabel: 'Continue',
  }) as StepSchema

  const OutcomesSchema = object({
    case_study_outcomes: string()
      .default('')
      .meta({
        label: 'What was the result?',
        placeholder: 'Describe the specific results, metrics, ROI, or other outcomes achieved...',
        type: 'textarea',
        rows: 4,
      })
      .transform(safify),
  }).meta({
    title: 'What outcomes did the customer achieve?',
    submitLabel: 'Continue',
  }) as StepSchema

  const RefineDetailsSchema = object({
    tone: tone.meta({
      autoFill: true,
    }),
    filename,
    project,
    language: language.meta({ overflow: true, autoFill: true }),
    include_emojis: includeEmojis.meta({ overflow: true, autoFill: true }),
  }).meta({
    title: 'Refine the details',
    submitLabel: 'Generate Case Study',
  }) as StepSchema

  return {
    meta,
    steps: [BasicsSchema, ChallengeSchema, BusinessHelpSchema, OutcomesSchema, RefineDetailsSchema],
  } as MultiStepSchema<GenerationType>
}
